import { Component } from '@angular/core';
import { EmailService } from '../Service/email.service';
import { IpServiceService } from '../Service/ip.service.service';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { HelperService } from '../Service/helper.service';
import { AlertService } from '../Service/alert.service';
import { ModalAlertasComponent } from "../Shared/Ui/landig/Alerts/modal-alertas/modal-alertas.component"; // <--- Importa el servicio de alertas

interface Feature {
  icon: string;
  title: string;
  description: string;
}

@Component({
  selector: 'app-home2',
  imports: [ReactiveFormsModule, ModalAlertasComponent],
  templateUrl: './home2.component.html',
  styleUrls: ['./home2.component.scss']
})
export class Home2Component {
  constructor(
    private fb: FormBuilder,
    private emailService: EmailService,
    private ipService: IpServiceService,
    private helperService: HelperService,
    private alertService: AlertService // <--- Inyecta el servicio de alertas
  ) {
    this.contactoForm = this.fb.group({
      nombre: ['', [Validators.required]],
      phone: ['', [Validators.required]],
      email: ['', [Validators.required, Validators.email]],
      empresa: [''],
    });
  }
  userIp: string | undefined;
  contactoForm: FormGroup;
  features: Feature[] = [
    {
      icon: '../assets/images/img_acceso_1.png',
      title: 'Identificación Rápida',
      description: 'Proporciona los datos básicos de la empresa y su sector. Nuestro sistema se encarga del resto, agilizando el proceso de evaluación.'
    },
    {
      icon: '../assets/images/img_incorporacion_1.png',
      title: 'Análisis Automatizado',
      description: 'Carga los estados financieros o la carpeta tributaria. Nuestra IA procesa y analiza la información en minutos.'
    },
    {
      icon: '../assets/images/img_credito_3.png',
      title: 'Reporte Detallado',
      description: 'Obtén un informe completo con el score de riesgo, capacidad económica e indicadores clave para una toma de decisiones informada.'
    }
  ];

   ngAfterViewInit(): void {
    this.getUserIp();
    const section = document.querySelector('.how-it-works');
    if (section) {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            section.classList.add('in-view');
          } else {
            section.classList.remove('in-view');
          }
        },
        { threshold: 0.3 }
      );
      observer.observe(section);
    }
  }

  onEvaluate(event: Event): void {
    event.preventDefault();
    this.llamarAlerta(
      'info',
      'Iniciando proceso de evaluación de empresa...',
      () => {}
    );
  }

  onContact(event: Event): void {
    event.preventDefault();
    this.llamarAlerta(
      'info',
      'Abriendo formulario de contacto...',
      () => {}
    );
  }

  onLogin(event: Event): void {
    event.preventDefault();
    this.llamarAlerta(
      'info',
      'Abriendo panel de inicio de sesión...',
      () => {}
    );
  }

  scrollToSection(event: Event, sectionId: string): void {
    event.preventDefault();
    const el = document.getElementById(sectionId);
    if (el) {
      window.scrollTo({ top: el.offsetTop - 100, behavior: 'smooth' });
    }
  }

  onSubmit(): void {
    if (this.contactoForm.invalid) {
      this.contactoForm.markAllAsTouched();
      this.llamarAlerta(
        'error',
        'Por favor, completa todos los campos obligatorios correctamente.',
        () => {}
      );
      return;
    }
    const nombre = this.contactoForm.controls['nombre'].value;
    const telefono = this.contactoForm.controls['phone'].value;
    const email = this.contactoForm.controls['email'].value;
    const empresa = this.contactoForm.controls['empresa'].value;
    const formData = {
      nombre: nombre,
      telefono: telefono,
      email: email,
      empresa: empresa,
      ip: this.userIp || '',
    };

    this.helperService.sendContactForm(formData).subscribe({
      next: (response) => {
        this.llamarAlerta(
          'response',
          'Formulario enviado correctamente. Nos pondremos en contacto contigo pronto.',
          () => {
            this.contactoForm.reset();
            // (document.getElementById('contactModal') as any)?.modal('hide');
          }
        );
      },
      error: (error) => {
        this.llamarAlerta(
          'error',
          'Hubo un error al enviar el formulario. Por favor, inténtalo de nuevo más tarde.',
          () => {}
        );
      }
    });
  }

  llamarAlerta(
    alertType: string,
    message: string,
    confirmAction: () => void,
    cancelAction: () => void = () => {}
  ): void {
    this.alertService.showAlert(
      alertType,
      message,
      confirmAction,
      cancelAction
    );
  }

  getUserIp(): void {
    this.ipService.getIp().subscribe((data) => {
      this.userIp = data.ip;
    });}}
